module.exports = __webpack_public_path__ + "img/3.775a5e09.svg";